import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/add_icon.svg'


const _hoisted_1 = {
  key: 0,
  class: "loader-container"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "loader" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "counterparties-paywall"
}
const _hoisted_5 = {
  key: 0,
  class: "d-flex flex-column sub-header sub-header--preview mt-4"
}
const _hoisted_6 = { class: "d-md-flex sub-header__title sub-header__title--preview align-items-center" }
const _hoisted_7 = { class: "paywall-company" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "paywall-company__eyebrow" }, "Компания найдена", -1)
const _hoisted_9 = { class: "ms-md-4 mb-md-0 mb-2" }
const _hoisted_10 = {
  key: 0,
  class: "paywall-company__meta ms-md-4"
}
const _hoisted_11 = { class: "d-flex ms-auto mt-md-0 mt-3 gap-3 align-items-center paywall-actions" }
const _hoisted_12 = { class: "d-flex sub-header__navs paywall-tabs" }
const _hoisted_13 = { class: "nav nav-tabs counterparties-tabs w-100 justify-content-between mx-4" }
const _hoisted_14 = {
  key: 0,
  class: "nav-item counterparties-more"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "counterparties-more__toggle" }, "Ещё", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "paywall-preview mt-4" }
const _hoisted_18 = {
  class: "paywall-preview__blur",
  "aria-hidden": "true"
}
const _hoisted_19 = { class: "paywall-preview__grid" }
const _hoisted_20 = { class: "paywall-preview-card__label" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "paywall-preview-card__line paywall-preview-card__line--wide" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "paywall-preview-card__line" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "paywall-preview-card__line paywall-preview-card__line--short" }, null, -1)
const _hoisted_24 = { class: "paywall-preview__overlay" }
const _hoisted_25 = {
  key: 1,
  class: "row mt-4"
}
const _hoisted_26 = { class: "col-12" }
const _hoisted_27 = { class: "card empty-state-card access-card" }
const _hoisted_28 = { class: "card-body text-center py-5" }
const _hoisted_29 = { class: "mb-3" }
const _hoisted_30 = { class: "text-muted mb-4" }
const _hoisted_31 = { class: "d-flex flex-column sub-header mt-4" }
const _hoisted_32 = { class: "d-md-flex sub-header__title align-items-center" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "img d-none" }, null, -1)
const _hoisted_34 = { class: "ms-md-4 mb-md-0 mb-2" }
const _hoisted_35 = { class: "d-flex ms-auto mt-md-0 mt-2 gap-3 align-items-center" }
const _hoisted_36 = ["disabled", "title"]
const _hoisted_37 = {
  key: 1,
  class: "loader my-0 mx-auto",
  style: {"width":"1.2rem","height":"1.2rem","border-width":"0.15rem"}
}
const _hoisted_38 = ["disabled"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_40 = {
  key: 1,
  class: "ms-4"
}
const _hoisted_41 = { class: "d-flex sub-header__navs" }
const _hoisted_42 = { class: "nav nav-tabs counterparties-tabs w-100 justify-content-between mx-4" }
const _hoisted_43 = ["id", "href", "aria-controls", "aria-selected", "onClick"]
const _hoisted_44 = {
  key: 0,
  ref: "moreMenuRef",
  class: "nav-item counterparties-more"
}
const _hoisted_45 = ["aria-expanded"]
const _hoisted_46 = ["id", "onClick"]
const _hoisted_47 = {
  key: 0,
  class: "row mt-4"
}
const _hoisted_48 = { class: "tab-content" }
const _hoisted_49 = ["id", "aria-labelledby"]
const _hoisted_50 = ["id", "aria-labelledby"]
const _hoisted_51 = ["id", "aria-labelledby"]
const _hoisted_52 = ["id", "aria-labelledby"]
const _hoisted_53 = ["id", "aria-labelledby"]
const _hoisted_54 = ["id", "aria-labelledby"]
const _hoisted_55 = ["id", "aria-labelledby"]
const _hoisted_56 = {
  key: 1,
  class: "card empty-state-card"
}
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Для этой карточки пока нет данных по блоку надежности.")
], -1)
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = ["id", "aria-labelledby"]
const _hoisted_60 = ["id", "aria-labelledby"]
const _hoisted_61 = ["id", "aria-labelledby"]
const _hoisted_62 = ["id", "aria-labelledby"]
const _hoisted_63 = ["id", "aria-labelledby"]
const _hoisted_64 = ["id", "aria-labelledby"]
const _hoisted_65 = ["id", "aria-labelledby"]
const _hoisted_66 = ["id", "aria-labelledby"]
const _hoisted_67 = ["id", "aria-labelledby"]
const _hoisted_68 = ["id", "aria-labelledby"]
const _hoisted_69 = {
  key: 3,
  class: "row mt-4"
}
const _hoisted_70 = { class: "col-12" }
const _hoisted_71 = { class: "card empty-state-card" }
const _hoisted_72 = { class: "card-body text-center py-5" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("h4", { class: "mb-3" }, "Карточка не найдена", -1)
const _hoisted_74 = { class: "mb-3" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("p", { class: "text-muted mb-4" }, "Попробуйте открыть результат из поиска заново или уточнить запрос.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Summary = _resolveComponent("Summary")!
  const _component_Arbitration = _resolveComponent("Arbitration")!
  const _component_Finances = _resolveComponent("Finances")!
  const _component_Connections = _resolveComponent("Connections")!
  const _component_Trademarks = _resolveComponent("Trademarks")!
  const _component_Founders = _resolveComponent("Founders")!
  const _component_Analyze = _resolveComponent("Analyze")!
  const _component_Debts = _resolveComponent("Debts")!
  const _component_Sanctions = _resolveComponent("Sanctions")!
  const _component_Leasing = _resolveComponent("Leasing")!
  const _component_Inspections = _resolveComponent("Inspections")!
  const _component_History = _resolveComponent("History")!
  const _component_Details = _resolveComponent("Details")!
  const _component_Okved = _resolveComponent("Okved")!
  const _component_Branches = _resolveComponent("Branches")!
  const _component_Licenses = _resolveComponent("Licenses")!
  const _component_Contracts = _resolveComponent("Contracts")!

  return (_openBlock(), _createElementBlock("div", {
    key: _ctx.route.params.id,
    class: "container counterparties"
  }, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : (_ctx.accessDenied)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_ctx.companyPreview)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.previewName), 1),
                      (_ctx.previewMeta.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.previewMeta, (item) => {
                              return (_openBlock(), _createElementBlock("span", { key: item }, _toDisplayString(item), 1))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.previewStatus)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass(["status ms-md-4", _ctx.getClass(_ctx.previewStatus)])
                        }, _toDisplayString(_ctx.previewStatus), 3))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_11, [
                      (_ctx.accessDeniedStatus === 401 || !_ctx.isLoggedIn)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "border-button btn-primary py-2 px-4",
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openAuthModal && _ctx.openAuthModal(...args)))
                          }, " Войти "))
                        : (_openBlock(), _createBlock(_component_router_link, {
                            key: 1,
                            class: "border-button btn-primary py-2 px-4",
                            to: { path: '/', hash: '#pricing-section' }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Оплатить тариф ")
                            ]),
                            _: 1
                          }))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("ul", _hoisted_13, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleTabs, (tab) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: tab.id,
                          class: "nav-item"
                        }, [
                          _createElementVNode("span", null, _toDisplayString(tab.label), 1)
                        ]))
                      }), 128)),
                      (_ctx.hiddenItems.length > 0)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_14, _hoisted_16))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paywallFeatures, (feature) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: feature,
                      class: "paywall-preview-card"
                    }, [
                      _createElementVNode("span", _hoisted_20, _toDisplayString(feature), 1),
                      _hoisted_21,
                      _hoisted_22,
                      _hoisted_23
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("h4", null, _toDisplayString(_ctx.accessDeniedTitle), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.accessDeniedDescription), 1),
                (_ctx.accessDeniedStatus === 401 || !_ctx.isLoggedIn)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "border-button btn-primary py-2 px-4",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openAuthModal && _ctx.openAuthModal(...args)))
                    }, " Войти "))
                  : (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      class: "border-button btn-primary py-2 px-4",
                      to: { path: '/', hash: '#pricing-section' }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Оплатить тариф ")
                      ]),
                      _: 1
                    }))
              ])
            ]),
            (!_ctx.companyPreview)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("h4", _hoisted_29, _toDisplayString(_ctx.accessDeniedTitle), 1),
                        _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.accessDeniedDescription), 1),
                        (_ctx.accessDeniedStatus === 401 || !_ctx.isLoggedIn)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "border-button btn-primary py-2 px-4",
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openAuthModal && _ctx.openAuthModal(...args)))
                            }, " Войти "))
                          : (_openBlock(), _createBlock(_component_router_link, {
                              key: 1,
                              class: "border-button btn-primary py-2 px-4",
                              to: { path: '/', hash: '#pricing-section' }
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Оплатить тариф ")
                              ]),
                              _: 1
                            }))
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_ctx.company)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("h3", _hoisted_34, _toDisplayString(_ctx.displayName), 1),
                  (_ctx.company.status?.name)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(["status ms-md-4", _ctx.getClass(_ctx.company.status?.name)])
                      }, _toDisplayString(_ctx.company.status?.name), 3))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("button", {
                      class: "border-button btn-primary py-1",
                      disabled: _ctx.isUpdating || !_ctx.canRefreshFromChecko,
                      title: 
                _ctx.canRefreshFromChecko
                  ? 'Запросить актуальные данные из Checko'
                  : 'Обновление недоступно для этой карточки'
              ,
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.updateCompanyData && _ctx.updateCompanyData(...args)))
                    }, [
                      (!_ctx.isUpdating)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode("Обновить данные")
                          ], 64))
                        : (_openBlock(), _createElementBlock("div", _hoisted_37))
                    ], 8, _hoisted_36),
                    _createElementVNode("button", {
                      class: "border-button btn-primary py-1",
                      disabled: !_ctx.company,
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.downloadCompanyInfo && _ctx.downloadCompanyInfo(...args)))
                    }, " Скачать карточку ", 8, _hoisted_38)
                  ]),
                  (_ctx.isLoggedIn && _ctx.company.representative && _ctx.company.representative != _ctx.currentUser.id)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (!_ctx.isFriend)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "border-button btn-primary ms-4 py-1",
                              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addFriend && _ctx.addFriend(...args)))
                            }, [
                              _hoisted_39,
                              _createTextVNode(" Добавить в друзья ")
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_40, "Добавлен в друзья"))
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("ul", _hoisted_42, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleTabs, (tab) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: tab.id,
                        class: "nav-item"
                      }, [
                        _createElementVNode("a", {
                          id: tab.id + '-tab' + _ctx.currentId,
                          class: _normalizeClass({ active: _ctx.activeTab === tab.id + _ctx.currentId }),
                          "data-bs-toggle": "tab",
                          href: '#' + tab.id + _ctx.currentId,
                          role: "tab",
                          "aria-controls": tab.id + _ctx.currentId,
                          "aria-selected": _ctx.activeTab === tab.id + _ctx.currentId,
                          onClick: ($event: any) => (_ctx.setActiveTab(tab.id))
                        }, _toDisplayString(tab.label), 11, _hoisted_43)
                      ]))
                    }), 128)),
                    (_ctx.hiddenItems.length > 0)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_44, [
                          _createElementVNode("button", {
                            ref: "moreToggleRef",
                            type: "button",
                            class: "nav-link dropdown-toggle counterparties-more__toggle",
                            "aria-expanded": _ctx.isDropdownOpen,
                            onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)), ["stop"]))
                          }, " Ещё ", 8, _hoisted_45)
                        ], 512))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.isDropdownOpen)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "counterparties-more__menu",
                        style: _normalizeStyle(_ctx.dropdownMenuStyle)
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hiddenItems, (hiddenItem, index) => {
                          return (_openBlock(), _createElementBlock("button", {
                            id: hiddenItem.id + '-tab' + _ctx.currentId,
                            key: index,
                            type: "button",
                            class: _normalizeClass(["dropdown-item", {
                active: _ctx.activeTab === hiddenItem.id + _ctx.currentId,
              }]),
                            onClick: ($event: any) => (_ctx.setActiveTab(hiddenItem.id))
                          }, _toDisplayString(hiddenItem.label), 11, _hoisted_46))
                        }), 128)),
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "/marketplace",
                          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeDropdown && _ctx.closeDropdown(...args)))
                        }, "Маркетплейс")
                      ], 4))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_ctx.company)
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", {
                        id: 'tab-summary' + _ctx.currentId,
                        class: _normalizeClass(["tab-pane fade", {
              'show active': _ctx.activeTab === 'tab-summary' + _ctx.currentId,
            }]),
                        role: "tabpanel",
                        "aria-labelledby": 'tab-summary-tab' + _ctx.currentId
                      }, [
                        _createVNode(_component_Summary, {
                          company: _ctx.company,
                          finances: _ctx.companyFinances,
                          inspections: _ctx.companyInspections,
                          enforcements: _ctx.companyEnforcements,
                          contracts: _ctx.companyContracts,
                          connections: _ctx.companyConnections,
                          "fedresurs-messages": _ctx.companyFedresurs,
                          "bankruptcy-messages": _ctx.companyBankruptcyMessages,
                          "cases-amount": _ctx.companyLegalCases?.length || 0,
                          onChangeTab: _ctx.setActiveTab
                        }, null, 8, ["company", "finances", "inspections", "enforcements", "contracts", "connections", "fedresurs-messages", "bankruptcy-messages", "cases-amount", "onChangeTab"])
                      ], 10, _hoisted_49),
                      _createElementVNode("div", {
                        id: 'tab-arbitration' + _ctx.currentId,
                        class: "tab-pane fade",
                        role: "tabpanel",
                        "aria-labelledby": 'tab-arbitration-tab' + _ctx.currentId
                      }, [
                        _createVNode(_component_Arbitration, { cases: _ctx.companyLegalCases }, null, 8, ["cases"])
                      ], 8, _hoisted_50),
                      (_ctx.companyFinances)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            id: 'tab-finances' + _ctx.currentId,
                            class: "tab-pane fade",
                            role: "tabpanel",
                            "aria-labelledby": 'tab-finances-tab' + _ctx.currentId
                          }, [
                            _createVNode(_component_Finances, {
                              finances: _ctx.companyFinances,
                              html: _ctx.company?.html_checko
                            }, null, 8, ["finances", "html"])
                          ], 8, _hoisted_51))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        id: 'tab-connections' + _ctx.currentId,
                        class: "tab-pane fade",
                        role: "tabpanel",
                        "aria-labelledby": 'tab-connections-tab' + _ctx.currentId
                      }, [
                        _createVNode(_component_Connections, { connections: _ctx.companyConnections }, null, 8, ["connections"])
                      ], 8, _hoisted_52),
                      _createElementVNode("div", {
                        id: 'tab-trademarks' + _ctx.currentId,
                        class: "tab-pane fade",
                        role: "tabpanel",
                        "aria-labelledby": 'tab-trademarks-tab' + _ctx.currentId
                      }, [
                        _createVNode(_component_Trademarks, {
                          trademarks: _ctx.company.trademarks
                        }, null, 8, ["trademarks"])
                      ], 8, _hoisted_53),
                      _createElementVNode("div", {
                        id: 'tab-founders' + _ctx.currentId,
                        class: "tab-pane fade",
                        role: "tabpanel",
                        "aria-labelledby": 'tab-founders-tab' + _ctx.currentId
                      }, [
                        _createVNode(_component_Founders, { founders: _ctx.companyFounders }, null, 8, ["founders"])
                      ], 8, _hoisted_54),
                      _createElementVNode("div", {
                        id: 'tab-reliability' + _ctx.currentId,
                        class: "tab-pane fade",
                        role: "tabpanel",
                        "aria-labelledby": 'tab-reliability-tab' + _ctx.currentId
                      }, [
                        (_ctx.company.html_checko)
                          ? (_openBlock(), _createBlock(_component_Analyze, {
                              key: 0,
                              company: _ctx.company
                            }, null, 8, ["company"]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_56, _hoisted_58))
                      ], 8, _hoisted_55),
                      _createElementVNode("div", {
                        id: 'tab-debts' + _ctx.currentId,
                        class: "tab-pane fade",
                        role: "tabpanel",
                        "aria-labelledby": 'tab-debts-tab' + _ctx.currentId
                      }, [
                        _createVNode(_component_Debts, { enforcements: _ctx.companyEnforcements }, null, 8, ["enforcements"])
                      ], 8, _hoisted_59),
                      _createElementVNode("div", {
                        id: 'tab-sanctions' + _ctx.currentId,
                        class: "tab-pane fade",
                        role: "tabpanel",
                        "aria-labelledby": 'tab-sanctions-tab' + _ctx.currentId
                      }, [
                        _createVNode(_component_Sanctions, {
                          "has-sanctions": _ctx.company.sanctions,
                          sanctions_countries: _ctx.company.country_sanctions
                        }, null, 8, ["has-sanctions", "sanctions_countries"])
                      ], 8, _hoisted_60),
                      _createElementVNode("div", {
                        id: 'tab-leasing' + _ctx.currentId,
                        class: "tab-pane fade",
                        role: "tabpanel",
                        "aria-labelledby": 'tab-leasing-tab' + _ctx.currentId
                      }, [
                        _createVNode(_component_Leasing)
                      ], 8, _hoisted_61),
                      _createElementVNode("div", {
                        id: 'tab-inspections' + _ctx.currentId,
                        class: "tab-pane fade",
                        role: "tabpanel",
                        "aria-labelledby": 'tab-inspections-tab' + _ctx.currentId
                      }, [
                        _createVNode(_component_Inspections, { inspections: _ctx.companyInspections }, null, 8, ["inspections"])
                      ], 8, _hoisted_62),
                      _createElementVNode("div", {
                        id: 'tab-history' + _ctx.currentId,
                        class: "tab-pane fade",
                        role: "tabpanel",
                        "aria-labelledby": 'tab-history-tab' + _ctx.currentId
                      }, [
                        _createVNode(_component_History, {
                          "timeline-events": _ctx.companyTimeline,
                          "fedresurs-messages": _ctx.companyFedresurs,
                          "bankruptcy-messages": _ctx.companyBankruptcyMessages
                        }, null, 8, ["timeline-events", "fedresurs-messages", "bankruptcy-messages"])
                      ], 8, _hoisted_63),
                      _createElementVNode("div", {
                        id: 'tab-details' + _ctx.currentId,
                        class: "tab-pane fade",
                        role: "tabpanel",
                        "aria-labelledby": 'tab-details-tab' + _ctx.currentId
                      }, [
                        _createVNode(_component_Details, { company: _ctx.company }, null, 8, ["company"])
                      ], 8, _hoisted_64),
                      _createElementVNode("div", {
                        id: 'tab-okved' + _ctx.currentId,
                        class: "tab-pane fade",
                        role: "tabpanel",
                        "aria-labelledby": 'tab-okved-tab' + _ctx.currentId
                      }, [
                        _createVNode(_component_Okved, { company: _ctx.company }, null, 8, ["company"])
                      ], 8, _hoisted_65),
                      _createElementVNode("div", {
                        id: 'tab-branches' + _ctx.currentId,
                        class: "tab-pane fade",
                        role: "tabpanel",
                        "aria-labelledby": 'tab-branches-tab' + _ctx.currentId
                      }, [
                        _createVNode(_component_Branches, {
                          branches: _ctx.company.division && _ctx.company.division?.length ? _ctx.company?.division[0]?.filials : []
                        }, null, 8, ["branches"])
                      ], 8, _hoisted_66),
                      _createElementVNode("div", {
                        id: 'tab-licenses' + _ctx.currentId,
                        class: "tab-pane fade",
                        role: "tabpanel",
                        "aria-labelledby": 'tab-licenses-tab' + _ctx.currentId
                      }, [
                        _createVNode(_component_Licenses, {
                          licenses: _ctx.company.licenses
                        }, null, 8, ["licenses"])
                      ], 8, _hoisted_67),
                      _createElementVNode("div", {
                        id: 'tab-contracts' + _ctx.currentId,
                        class: "tab-pane fade",
                        role: "tabpanel",
                        "aria-labelledby": 'tab-contracts-tab' + _ctx.currentId
                      }, [
                        (_ctx.companyContracts)
                          ? (_openBlock(), _createBlock(_component_Contracts, {
                              key: 0,
                              contracts: _ctx.companyContracts
                            }, null, 8, ["contracts"]))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_68)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_69, [
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("div", _hoisted_72, [
                    _hoisted_73,
                    _createElementVNode("p", _hoisted_74, [
                      _createTextVNode(" Не удалось загрузить данные по запросу "),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.route.params.id), 1),
                      _createTextVNode(". ")
                    ]),
                    _hoisted_75,
                    _createVNode(_component_router_link, {
                      class: "border-button btn-primary py-2 px-4",
                      to: "/"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Вернуться на главную ")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]))
  ]))
}